import { render, staticRenderFns } from "./BrandEditor.vue?vue&type=template&id=1abf911f&"
import script from "./BrandEditor.vue?vue&type=script&lang=js&"
export * from "./BrandEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports